module.exports = __webpack_public_path__ + "img/hui_image.5dff8cdd.png";